export default "__VITE_ASSET__b9a558d0__"